import { Controller } from "@hotwired/stimulus";
import axios  from 'axios'
import feather from 'feather-icons'
import consumer from "../channels/consumer"
import _ from 'lodash';
import $ from 'jquery';

export default class extends Controller {
  static targets = [
    "form",
    "list",
    "ratingButtons",
    "filterCheckbox",
    "clearFiltersBtn",
    "results",
    "spinner"
  ]

  initialize() {
    this.room_id = this.data.get('room')
    this.updateSearchParams();
    this.fetchHotels = _.debounce(this.fetchHotels, 1000, { 'leading': false })
  }

  connect() {
    this.toggleClearFiltersBtn();
    this.fetchHotelsDetails();
  }

  disconnect() {
    this.channel.unsubscribe();
  }

  toggleClearFiltersBtn() {
    if($(this.filterCheckboxTargets).is(':checked')) {
      $(this.clearFiltersBtnTarget).show();
    } else {
      $(this.clearFiltersBtnTarget).hide();
    }
  }

  updateRating(e) {
    const selectedRating = e.target.value;

    this.ratingButtonsTargets.forEach(label => {
      const buttonRating = label.querySelector('input[type="radio"]').value;
      label.classList.toggle("active", buttonRating === selectedRating);
    });
  }

  clearFilters(e) {
    e.preventDefault();
    $(this.filterCheckboxTargets).prop('checked', false);
    $(this.clearFiltersBtnTarget).hide();
    this.fetchHotels();
  }

  fetchHotels() {
    if (this.hasListTarget) { $(this.listTarget).addClass('opacity-20') };
    $(this.spinnerTarget).show();

    let queryString = `?${$(this.formTarget).serialize()}`
    var url = [location.protocol, '//', location.host, location.pathname].join('');

    axios.get(
      `/hotels${queryString}`,
      {headers: {'X-Requested-With': 'XMLHttpRequest'}}
    ).then(res => {
      $(this.resultsTarget).html(res.data);
      feather.replace();
      this.toggleClearFiltersBtn();
      window.history.replaceState(null, '', url + queryString);
      this.updateSearchParams();
      this.channel.perform('get_hotels', this.searchParams);
      $(this.spinnerTarget).hide();
      if (this.hasListTarget) { $(this.listTarget).removeClass('opacity-20') };
    })
  }

  updateSearchParams() {
    if (!this.hasListTarget) { return };
    this.searchParams = JSON.parse(this.listTarget.dataset.hotelSearchParams);
  }

  fetchHotelsDetails() {
    var self = this;

    return new Promise((resolve) => {
      self.channel = consumer.subscriptions.create(
        {
          channel: 'HotelSearchChannel',
          room_id: self.room_id
        } ,
        {
          connected() {
            if (self.isSearchPeriodAvailable()) {
              this.perform('get_hotels', self.searchParams);
            }
            resolve();
          },
          received(data) {
            if (data['action'] === 'updateRates') {
              let payload = data.payload.rates

              for (var hotelSlug in payload) {
                self.updateHotelDetails(hotelSlug, payload[hotelSlug])
              }

              self.reorderHotels();
            };
          }
        });
    });
  };

  updateHotelDetails(slug, data) {
    if (!this.hasListTarget) { return }
    $(this.listTarget)
      .find(`*[data-slug=${slug}]`)
      .trigger('dataChange', data)
  };

  isSearchPeriodAvailable() {
    return  this.searchParams &&
            this.searchParams['arrival_date'] != null &&
            this.searchParams['departure_date'] != null;
  }

  reorderHotels() {
    if (this.hasListTarget) {
      const hotelCardsWithoutPrice = Array.from(this.listTarget.children).filter((el) => el.querySelector('[data-hotel-search-price-presence-value]')?.dataset?.hotelSearchPricePresenceValue != 'true');
      hotelCardsWithoutPrice.forEach((hotelCard) => this.listTarget.appendChild(hotelCard));
    };
  };
}
